import React from 'react'
import styled from 'styled-components'

import Nav from './components/Nav'

const Footer: React.FC = () => (
  <StyledFooter>
    <StyledFooterInner>
      <Nav />
      <Copy>© InsureDAO 2021 All rights reserved</Copy>
    </StyledFooterInner>
  </StyledFooter>
)

const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  justify-content: center;
`
const StyledFooterInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: ${props => props.theme.topBarSize}px;
  max-width: ${props => props.theme.siteWidth}px;
  width: 100%;
  flex-direction:column;
`
const Copy = styled.div`
  color: ${(props) => props.theme.color.white};
  align-items: center;
  display: flex;
  font-size: 12px;
  padding-top:5px;
  justify-content: center;
`

export default Footer